module.exports = __webpack_public_path__ + "media/public/images/logo_jc-1ff71abacf94553935a67d813f68f6e2.png";